import { useEffect } from 'react';

const SCRIPT_SRC = 'https://link.msgsndr.com/js/form_embed.js';

// Loads the LeadConnector form-embed script once for the whole app.
function useFormEmbedScript() {
  useEffect(() => {
    if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) return;
    const s = document.createElement('script');
    s.src = SCRIPT_SRC;
    s.async = true;
    document.body.appendChild(s);
  }, []);
}

// Reusable GoHighLevel / LeadConnector inline form embed.
export function LeadConnectForm({ formId, formName, height = 700, testid = 'leadconnect-form' }) {
  useFormEmbedScript();
  return (
    <iframe
      src={`https://api.leadconnectorhq.com/widget/form/${formId}`}
      style={{ width: '100%', height, border: 'none', borderRadius: 12, background: '#FFFFFF' }}
      id={`inline-${formId}`}
      data-testid={testid}
      data-layout="{'id':'INLINE'}"
      data-trigger-type="alwaysShow"
      data-activation-type="alwaysActivated"
      data-deactivation-type="neverDeactivate"
      data-form-name={formName}
      data-height={height}
      data-layout-iframe-id={`inline-${formId}`}
      data-form-id={formId}
      data-cookie-consent="true"
      data-cookie-consent-provider="auto"
      title={formName}
    />
  );
}

// Form IDs supplied by EGMG.
export const CHAUFFEUR_FORM_ID = 'th0s96cEubHW64hdPfpr';
export const LEASING_FORM_ID = 'WBkSEtvWBcHQSR3kUXo2';
